import { observer } from 'mobx-react';
import React from 'react';

import { PictureProfile } from '../../../../ResizedImage/PictureProfile.csharp';
import { getTranslation, keys } from '../../../../Resources/Translations';
import { Loader } from '../../../Components/Loader/Loader';
import { expectedDeliveryDate } from '../ExpectedDeliveryDate';
import { ExpectedDeliveryDateEmptyResults } from './ExpectedDeliveryDateEmptyResults';
import { ExpectedDeliveryDateMethod } from './ExpectedDeliveryDateMethod';
import { ExpectedDeliveryDateStep } from './ExpectedDeliveryDateModal';

interface IExpectedDeliveryDateResultsProps {
    step: ExpectedDeliveryDateStep;
    logoPictureProfile: PictureProfile;
    deliveryInfoUrl: string;
    logCustomEvent: (name: string, properties?: { [key: string]: string }) => void;
}

export const ExpectedDeliveryDateResults = observer(({ step, logoPictureProfile, deliveryInfoUrl, logCustomEvent }: IExpectedDeliveryDateResultsProps) => {
    if (step === ExpectedDeliveryDateStep.Loading) return <Loader className="ExpectedDeliveryDateResults__Loader" isLoading />;
    if (step !== ExpectedDeliveryDateStep.SelectMethod) return <ExpectedDeliveryDateEmptyResults step={step} deliveryInfoUrl={deliveryInfoUrl} />;

    return expectedDeliveryDate.deliveryMethods ? (
        <div className="ExpectedDeliveryDateResults">
            {expectedDeliveryDate.selectedDeliveryMethod && (
                <>
                    <h2 className="ExpectedDeliveryDateResults__Heading">{getTranslation(keys['expectedDeliveryDate.preferredMethod'])}</h2>
                    <ExpectedDeliveryDateMethod
                        deliveryInfoUrl={deliveryInfoUrl}
                        icon="/dist/assets/images/bookmark.svg"
                        method={expectedDeliveryDate.selectedDeliveryMethod}
                        highlighted
                        notAvailable={!expectedDeliveryDate.isDeliveryMethodAvailable(expectedDeliveryDate.selectedDeliveryMethod)}
                        logoPictureProfile={logoPictureProfile}
                        logCustomEvent={logCustomEvent}
                    />
                </>
            )}
            {expectedDeliveryDate.fastestDeliveryMethod && (
                <>
                    <h2 className="ExpectedDeliveryDateResults__Heading">{getTranslation(keys['expectedDeliveryDate.fastestMethod'])}</h2>
                    <ExpectedDeliveryDateMethod
                        deliveryInfoUrl={deliveryInfoUrl}
                        icon="/dist/assets/images/clock.svg"
                        method={expectedDeliveryDate.fastestDeliveryMethod}
                        highlighted
                        logoPictureProfile={logoPictureProfile}
                        logCustomEvent={logCustomEvent}
                    />
                </>
            )}
            <h2 className="ExpectedDeliveryDateResults__Heading">{getTranslation(keys['expectedDeliveryDate.allMethods'])}</h2>
            {expectedDeliveryDate.allDeliveryMethods.map((method) => (
                <ExpectedDeliveryDateMethod
                    method={method}
                    key={method.methodName}
                    logoPictureProfile={logoPictureProfile}
                    deliveryInfoUrl={deliveryInfoUrl}
                    notAvailable={!expectedDeliveryDate.isDeliveryMethodAvailable(method)}
                    logCustomEvent={logCustomEvent}
                />
            ))}
        </div>
    ) : null;
});
